
/**
 * 获取媒体信息 wasm
 * MPEG-4\JPEG\JPG\PNG
 */
const getMediaInfo = (file) => {
    return new Promise((resolve, reject) => {
        if (!file) reject("文件不能为空");
        let returnResult = {};
        MediaInfo({ format: 'object' }, (mediainfo) => {
            const getSize = () => file.size;
            console.log('file', getSize)
            const readChunk = (chunkSize, offset) =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        if (event.target.error) {
                            reject(event.target.error);
                        }
                        resolve(new Uint8Array(event.target.result));
                    };
                    reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize));
                });

            mediainfo
                .analyzeData(getSize, readChunk)
                .then((result) => {
                    const track = result.media.track[0]; // 当前第一轨道 为常规信息 格式 大小等 但视频大小于第二轨道有细微差别
                    console.log(result)
                    const encodingFormat = track.Format;
                    returnResult['name'] = result.creatingLibrary.name
                    if (!encodingFormat) {
                        returnResult['format'] = '';
                        resolve(returnResult);
                    }

                    returnResult['format'] = encodingFormat;
                    returnResult['fileSize'] = Number(track.FileSize);

                    const track_1 = result.media.track[1];

                    returnResult['width'] = Number(track_1.Width)
                    returnResult['height'] = Number(track_1.Height)

                    if(encodingFormat == 'MPEG-4') {
                        returnResult['duration'] = Number(track_1.Duration)
                    }

                    resolve(returnResult);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    });
};


export default getMediaInfo;


